import React from 'react';
import { inject, observer } from 'mobx-react';
import { Router, Route, browserHistory, IndexRoute, Redirect } from 'react-router';
import { hot } from 'react-hot-loader';
import 'regenerator-runtime/runtime';
import Loadable from 'react-loadable';
import { IntlProvider } from 'react-intl';
import App from './containers/App';
import Page404 from './pages/404';

import TrackingInfo from './pages/TrackingInfo';

const Loading = () => <div>Loading...</div>;

const AsyncExternalOrders = Loadable({
  loader: () => import('./pages/ExternalOrders'),
  loading: Loading,
  delay: 300,
});

const AsyncReports = Loadable({
  loader: () => import('./pages/Reports'),
  loading: Loading,
  delay: 300,
});

const BifmUserRoutes = ({ localeStore }) => (
  <IntlProvider
    key={localeStore.language}
    locale={localeStore.language}
    messages={localeStore.messages}
    textComponent={React.Fragment}
  >
    <Router history={browserHistory}>
      <Route path="/" component={App}>
        <IndexRoute component={AsyncExternalOrders} />
        <Redirect from="/externalOrders" to="externalOrders/table" />
        <Redirect from="/" to="externalOrders/table" />
        <Route path="externalOrders">
          <Route path="table" component={AsyncExternalOrders} />
          <Route
            path="trackingInfo/:code"
            component={props => <TrackingInfo headingId="orders" {...props} />}
          />
        </Route>
        <Route path="reports" component={AsyncReports} />
        <Route path="*" exact component={Page404} />
      </Route>
    </Router>
  </IntlProvider>
);

export default hot(module)(
  inject('localeStore')(inject('settingsStore')(observer(BifmUserRoutes))),
);
